/**
 * Adds width and height attributes to the canvas element and resizes the internal canvas resolution based on DPI
 */
const resizeCanvas = (riveAnimation) => {
  const canvas = riveAnimation.canvas

  let displayWidth = canvas.offsetWidth
  let displayHeight = canvas.offsetHeight

  const isSafari = (navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && !navigator.userAgent.match('CriOS'));
  const isWindowsFF = navigator.userAgent.toLowerCase().includes('firefox') && navigator.userAgent.toLowerCase().includes('windows');

  // ¯\_(ツ)_/¯ this makes it sharp / @2x
  let scale = 2;

  // Performance improvements
  if( isSafari || isWindowsFF ) {
    scale = 1.5;
  }

  canvas.width = scale * displayWidth
  canvas.height = scale * displayHeight

  riveAnimation.resizeToCanvas()
}

export { resizeCanvas }
